(function () {
  if (!document.documentElement.classList.contains('safari')) return;

  var busyUntil = 0;

  function rootUrl() {
    return window.__safariHomeRoot || window.Shopify?.routes?.root || '/';
  }

  function normalizePath(pathname) {
    var path = pathname || '/';
    return path.length > 1 && path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
  }

  function isHomepagePath(pathname) {
    var root = normalizePath(rootUrl());
    var path = normalizePath(pathname);
    return path === '/' || path === root;
  }

  function getHeaderHeight() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
  }

  function parseLink(href) {
    if (!href || href === '#') return null;
    try {
      var url = new URL(href, window.location.href);
      if (!url.hash) return null;
      return { url: url, hash: decodeURIComponent(url.hash) };
    } catch (e) {
      return null;
    }
  }

  function isBusy() { return Date.now() < busyUntil; }
  function lock(ms) { busyUntil = Date.now() + ms; }

  // Оставили только остановку видео, убрали transform,
  // который ломал position: sticky на хедере.
  function pauseMedia() {
    document.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch(e){} });
  }

  // ДОБАВЛЕНО: Математическая функция для плавного старта и остановки
  function customSmoothScroll(endY, duration) {
    var startY = window.scrollY || window.pageYOffset;
    var distanceY = endY - startY;
    var startTime = new Date().getTime();

    if (distanceY === 0) return;

    function easeInOutQuart(time, from, distance, dur) {
      if ((time /= dur / 2) < 1) return distance / 2 * Math.pow(time, 4) + from;
      return -distance / 2 * ((time -= 2) * Math.pow(time, 3) - 2) + from;
    }

    function step() {
      var time = new Date().getTime() - startTime;
      var newY = easeInOutQuart(time, startY, distanceY, duration);

      if (time >= duration) {
        window.scrollTo(0, endY);
        return;
      }
      window.scrollTo(0, newY);
      window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  // ОБНОВЛЕНО: Используем кастомный скролл
  function scrollToTarget(el) {
    if (isBusy()) return;
    lock(600); // Блокируем клики на время анимации (600мс)
    pauseMedia();

    var top = el.getBoundingClientRect().top + window.scrollY - getHeaderHeight() - 16;
    var finalTop = Math.max(0, top);

    var htmlBehavior = document.documentElement.style.scrollBehavior;
    var bodyBehavior = document.body.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';

    // Запускаем плавную анимацию за 500 миллисекунд
    customSmoothScroll(finalTop, 500);

    setTimeout(function () {
      document.documentElement.style.scrollBehavior = htmlBehavior;
      document.body.style.scrollBehavior = bodyBehavior;
    }, 550);
  }

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || isBusy()) return;

    var link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

    var href = link.getAttribute('href');
    var parsed = parseLink(href);
    if (!parsed) return;

    var hash = parsed.hash;
    var targetId = hash.slice(1);
    if (!targetId) return;

    var sameDocument =
        parsed.url.origin === window.location.origin &&
        normalizePath(parsed.url.pathname) === normalizePath(window.location.pathname) &&
        parsed.url.search === window.location.search;

    if (!sameDocument) {
      if (parsed.url.origin === window.location.origin) {
        event.preventDefault();
        event.stopImmediatePropagation();
        pauseMedia();

        var basePath = parsed.url.pathname + parsed.url.search;
        var separator = basePath.indexOf('?') !== -1 ? '&' : '?';
        var redirectUrl = basePath + separator + 'safari-target=' + encodeURIComponent(targetId);

        window.location.assign(redirectUrl);
      }
      return;
    }

    var target = document.getElementById(targetId);
    if (target) {
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToTarget(target);
      if (window.history.replaceState) {
        var originalId = target.id;
        target.id = originalId + '-temp';
        window.history.replaceState(null, '', hash);
        target.id = originalId;
      }
      return;
    }

    if (href.charAt(0) === '#') {
      event.preventDefault();
      event.stopImmediatePropagation();
      var base = rootUrl().replace(/\/$/, '') || '/';
      window.location.assign(base + '?safari-target=' + encodeURIComponent(targetId));
    }
  }, true);

  function handleUrlParamsOnLoad() {
    var urlParams = new URLSearchParams(window.location.search);
    var targetId = urlParams.get('safari-target');

    var activeHash = targetId ? '#' + targetId : window.location.hash;
    if (!activeHash) return;

    var cleanTargetId = activeHash.slice(1);
    if (!cleanTargetId) return;

    function executeScroll() {
      var attempts = 0;
      function attempt() {
        var el = document.getElementById(cleanTargetId);
        if (el) {
          scrollToTarget(el);

          if (window.history.replaceState) {
            var cleanUrl = window.location.pathname + window.location.search.replace(new RegExp('([?&])safari-target=' + targetId + '(&|$)'), '$1').replace(/[?&]$/, '') + activeHash;

            setTimeout(function() {
              var originalId = el.id;
              el.id = originalId + '-temp';
              window.history.replaceState(null, '', cleanUrl);
              el.id = originalId;
            }, 300);
          }
          return;
        }
        attempts += 1;
        if (attempts < 15) {
          window.setTimeout(attempt, 200);
        } else if (!isHomepagePath(window.location.pathname)) {
          var base = rootUrl().replace(/\/$/, '') || '/';
          window.location.assign(base + '?safari-target=' + cleanTargetId);
        }
      }
      attempt();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', executeScroll);
    } else {
      executeScroll();
    }
  }

  handleUrlParamsOnLoad();
})();